import { makeStyles } from '@material-ui/core'

export default makeStyles({
  button: {
    color: 'rgba(0,0,0,0.85)',
    padding: '0px',
  },
})
